import React from "react";
import Stack from "@mui/material/Stack";
import Snackbar, { SnackbarOrigin } from "@mui/material/Snackbar";
import Portal from "@mui/material/Portal";
import MuiAlert, { AlertProps, AlertColor } from "@mui/material/Alert";
import { SxProps, Theme } from "@mui/material";

export interface SnackBarProps {
  alert?: boolean;
  message: string;
  openState: boolean;
  autoHideDuration?: number;
  severity: AlertColor | undefined;
  sx?: SxProps<Theme>;
  onClose;
  anchorOriginVertical?: SnackbarOrigin["vertical"];
  anchorOriginHorizontal?: SnackbarOrigin["horizontal"];
}

const Alert = React.forwardRef<HTMLDivElement, AlertProps>(function Alert(
  props,
  ref
) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

export const WcSnackBar = (props: SnackBarProps) => {
  const {
    message,
    openState,
    onClose,
    severity,
    sx,
    autoHideDuration,
    anchorOriginVertical = "bottom",
    anchorOriginHorizontal = "right",
  } = props;
  const [open, setOpen] = React.useState(openState);
  const container = React.useRef(null);

  React.useEffect(() => {
    setOpen(openState);
  }, [openState]);

  const handleClose = (
    _event?: React.SyntheticEvent | Event,
    reason?: string
  ) => {
    if (reason === "clickaway") {
      return;
    }

    setOpen(false);
    onClose(false);
  };

  return (
    <Stack
      id="Snackbar"
      spacing={2}
      sx={[
        { width: "100%", marginLeft: 10 },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
    >
      <Portal container={container.current}>
        <Snackbar
          open={open}
          autoHideDuration={autoHideDuration ? autoHideDuration : 8000}
          onClose={handleClose}
          anchorOrigin={{
            vertical: anchorOriginVertical,
            horizontal: anchorOriginHorizontal,
          }}
        >
          <Alert
            onClose={handleClose}
            severity={severity}
            sx={{ width: "100%" }}
          >
            {message}
          </Alert>
        </Snackbar>
      </Portal>
    </Stack>
  );
};

export default WcSnackBar;
